import { useState, useEffect } from 'react';

const AVATAR_COLORS = ['#C9A668', '#60a5fa', '#c084fc', '#34d399'];

export default function CollaboratorBar({ users = [], currentUserId }) {
  const [toast, setToast] = useState(null);
  const others = users.filter(u => u.id !== currentUserId);

  // Show toast when someone joins/leaves
  useEffect(() => {
    if (others.length > 0) {
      const names = others.map(u => u.name?.split(' ')[0] || 'Someone');
      // Don't toast on initial load
    }
  }, [others.length]);

  if (others.length === 0) return null;

  return (
    <>
      <div className="card px-4 py-2.5 mb-3 flex items-center gap-3">
        {/* Live indicator */}
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
          <span className="text-[10px] text-emerald-400 font-medium uppercase tracking-wider">Live</span>
        </div>

        <div className="w-px h-4 bg-neutral-800" />

        {/* Avatars */}
        <div className="flex -space-x-2">
          {/* Current user */}
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-bold text-black border-2 border-black ring-2 ring-emerald-500/30 z-10"
            style={{ backgroundColor: AVATAR_COLORS[0] }}
            title="You"
          >
            You
          </div>
          {/* Others */}
          {others.slice(0, 3).map((user, i) => {
            const initial = (user.name || '?').charAt(0).toUpperCase();
            const color = AVATAR_COLORS[(i + 1) % AVATAR_COLORS.length];
            return (
              <div
                key={user.id}
                className="w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-bold text-black border-2 border-black"
                style={{ backgroundColor: color }}
                title={`${user.name}${user.editing ? ` — editing ${user.editing}` : ''}`}
              >
                {initial}
              </div>
            );
          })}
        </div>

        <div className="flex-1 min-w-0">
          <span className="text-xs text-neutral-400">
            {others.map(u => u.name?.split(' ')[0]).join(', ')} {others.length === 1 ? 'is' : 'are'} here
          </span>
        </div>

        {/* Who's editing what */}
        {others.some(u => u.editing) && (
          <div className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-gold animate-pulse" />
            <span className="text-[10px] text-neutral-500 truncate max-w-[200px]">
              {others.filter(u => u.editing).map(u => {
                const firstName = u.name?.split(' ')[0] || 'Someone';
                return `${firstName}: ${u.editing}`;
              }).join(' · ')}
            </span>
          </div>
        )}
      </div>

      {/* Toast notification */}
      {toast && (
        <div className="fixed bottom-4 right-4 z-50 bg-neutral-900 border border-neutral-700 rounded-lg px-4 py-3 shadow-xl animate-fade-in-up">
          <p className="text-xs text-neutral-300">{toast}</p>
        </div>
      )}
    </>
  );
}

// Export toast function for external use
export function showCollabToast(message, setToast) {
  setToast(message);
  setTimeout(() => setToast(null), 3000);
}
